__turbopack_context__.v({
  "active": "index-module-scss-module__sT3oOW__active",
  "icon": "index-module-scss-module__sT3oOW__icon",
  "item": "index-module-scss-module__sT3oOW__item",
  "separator": "index-module-scss-module__sT3oOW__separator",
  "switcher": "index-module-scss-module__sT3oOW__switcher",
  "trigger": "index-module-scss-module__sT3oOW__trigger",
});
